import { createClosingGame } from '../shared/closing-game.js';

// 6 distinct numbers (1-20) picked fresh every game, plus bull - same
// closing rules as Cricket/Tactics, just a randomized (and shorter) target
// list instead of a fixed one.
function pickRandomTargets() {
    const pool = Array.from({ length: 20 }, (_, i) => i + 1);
    // Fisher-Yates shuffle, then take the first 6.
    for (let i = pool.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [pool[i], pool[j]] = [pool[j], pool[i]];
    }
    const chosen = pool.slice(0, 6).sort((a, b) => b - a);
    return [...chosen, 'bull'];
}

export default createClosingGame({
    id: 'random-cricket',
    name: 'Random Cricket',
    description: "Cricket's rules, but with 6 random numbers (instead of a fixed 15-20) drawn fresh every game, plus the bull.",
    getTargets: pickRandomTargets,
    soleCloserScoring: true
});
